<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit SSL</span>
          <span v-else>Create a New SSL</span>
        </h1>
        <span>
          <router-link :to="{ name: 'ssls' }" class="btn btn_black"
            >Back to List</router-link
          >
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div
                :class="['form_row', { has_error: errorFor('customer_name') }]"
              >
                <label class="required">Customer</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="ssl.customer_name"
                  />
                  <v-errors :errors="errorFor('customer_name')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('domain_name') }]"
              >
                <label class="required">Domain name</label>
                <div class="form_input">
                  <input
                    type="text"
                    class="form_global"
                    v-model="ssl.domain_name"
                  />
                  <v-errors :errors="errorFor('domain_name')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('register_date') }]"
              >
                <label class="required">Register date</label>
                <div class="form_input">
                  <date-picker v-model:input="ssl.register_date"></date-picker>
                  <v-errors :errors="errorFor('register_date')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('expire_date') }]"
              >
                <label class="required">Expire date</label>
                <div class="form_input">
                  <date-picker v-model:input="ssl.expire_date"></date-picker>
                  <v-errors :errors="errorFor('expire_date')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('provider') }]">
                <label class="required">Provider</label>
                <div class="form_input">
                  <input
                    type="text"
                    class="form_global"
                    v-model="ssl.provider"
                  />
                  <v-errors :errors="errorFor('provider')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('memo') }]">
                <label>Memo</label>
                <div class="form_inline">
                  <text-editor
                    v-model:text="ssl['memo']"
                    :id="'memo'"
                  ></text-editor>
                  <v-errors :errors="errorFor('memo')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_6 pl_20">
              <div
                :class="[
                  'form_row',
                  { has_error: errorFor('ssl_organization') },
                ]"
              >
                <label class="required">SSL organization</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="ssl.ssl_organization"
                  />
                  <v-errors :errors="errorFor('ssl_organization')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('product') }]">
                <label class="required">Product</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="ssl.product"
                  />
                  <v-errors :errors="errorFor('product')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('type') }]">
                <label class="required">Type</label>
                <div class="form_inline">
                  <input type="text" class="form_global" v-model="ssl.type" />
                  <v-errors :errors="errorFor('type')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('password') }]">
                <label class="required">Password</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="ssl.password"
                  />
                  <v-errors :errors="errorFor('password')"></v-errors>
                </div>
              </div>
              <div class="form_row">
                <label></label>
                <div class="form_inline">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                    v-if="$route.params.id"
                  >
                    Update
                  </button>
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="submit"
                    v-else
                  >
                    Save
                  </button>
                  <router-link
                    v-if="$route.params.id"
                    :to="{ name: 'ssls' }"
                    class="btn btn_transparent has_border_radius ml_10"
                    >Cancel</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import TextEditor from '@/components/shared/TextEditor';
import DatePicker from '@/components/shared/DatePicker';
export default {
  name: 'ssl-form',
  components: { LoaderMaskComponent, TextEditor, DatePicker },
  data() {
    return {
      lyLoading: false,
      ssl: {
        customer_name: '',
        domain_name: '',
        register_date: '',
        expire_date: '',
        provider: '',
        ssl_organization: '',
        product: '',
        type: '',
        password: '',
        memo: '',
      },
    };
  },
  created() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    }
  },
  methods: {
    loadData(sslId) {
      this.lyLoading = true;
      this.axios
        .get('/ssls/' + sslId)
        .then((response) => {
          this.ssl = response.data.data;
        })
        .catch(() => {
          this.showFailMsg('No ssl exists!');
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      Object.keys(this.ssl).forEach((key) => {
        formData.append(key, this.ssl[key] ? this.ssl[key] : '');
      });

      this.axios
        .post('/ssls', formData)
        .then(() => {
          this.resetForm();
          this.showSuccessMsg('SSL Created Successfully!');
          this.$router.push({ name: 'ssls' });
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.ssl).forEach((key) => {
        formData.append(key, this.ssl[key] ? this.ssl[key] : '');
      });

      this.axios
        .post('/ssls/' + this.$route.params.id, formData)
        .then(() => {
          this.showSuccessMsg('SSL Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    resetForm() {
      this.ssl = {
        customer_name: '',
        domain_name: '',
        register_date: '',
        expire_date: '',
        provider: '',
        ssl_organization: '',
        product: '',
        type: '',
        password: '',
        memo: '',
      };
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
</style>
